(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-roles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // ── Accordion ──────────────────────────────────────────────
  const roleCards  = document.querySelectorAll('.careers-roles__card');
  const toggleBtns = document.querySelectorAll('[data-role-toggle]');

  toggleBtns.forEach((header) => {
    header.addEventListener('click', () => {
      const card   = header.closest('.careers-roles__card');
      const body   = card.querySelector('.careers-roles__card-body');
      const isOpen = card.classList.contains('careers-roles__card--open');

      roleCards.forEach((c) => {
        c.classList.remove('careers-roles__card--open');
        const b = c.querySelector('.careers-roles__card-body');
        const h = c.querySelector('[data-role-toggle]');
        if (b) b.setAttribute('aria-hidden', 'true');
        if (h) h.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        card.classList.add('careers-roles__card--open');
        body.setAttribute('aria-hidden', 'false');
        header.setAttribute('aria-expanded', 'true');
      }
    });

    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  // ── Modal ──────────────────────────────────────────────────
  const modal      = document.getElementById('careers-roles-apply-modal');
  if (!modal) return;

  const modalTitle = modal.querySelector('.careers-roles__modal-title');
  const roleInput  = modal.querySelector('.careers-roles__modal-role-input');
  const successMsg = modal.querySelector('.careers-roles__modal-message--success');
  const errorMsg   = modal.querySelector('.careers-roles__modal-message--error');
  const form       = document.getElementById('careers-roles-apply-form');

  const openModal = (roleTitle) => {
    if (modalTitle) modalTitle.textContent = roleTitle;
    if (roleInput)  roleInput.value        = roleTitle;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('careers-modal-open');
    setTimeout(() => {
      const firstInput = modal.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }, 50);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('careers-modal-open');
  };

  document.querySelectorAll('[data-open-modal]').forEach((btn) => {
    btn.addEventListener('click', () => openModal(btn.dataset.roleTitle || ''));
  });

  const closeBtn = modal.querySelector('[data-modal-close]');
  const backdrop = modal.querySelector('[data-modal-backdrop]');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // ── Phone: digits and + only ───────────────────────────────
  const phoneInput = modal.querySelector('#careers-roles-phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      phoneInput.value = phoneInput.value.replace(/[^\d+]/g, '');
    });
  }

  // ── On page reload after successful submission, re-open modal showing success ──
  if (form && form.dataset.posted === 'true') {
    openModal('');
    if (modalTitle) modalTitle.textContent = '';
    if (successMsg) successMsg.removeAttribute('hidden');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franchise-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-franchise-form]');
  if (!section || section.dataset.franchiseFormInitialized) return;
  section.dataset.franchiseFormInitialized = 'true';

  // ── Phone: allow digits and + only ─────────────────────────
  const phoneInput = section.querySelector('[data-franchise-phone]');
  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      phoneInput.value = phoneInput.value.replace(/[^\d+]/g, '');
    });
  }

  // ── Auto-dismiss flash messages after 5s ───────────────────
  const flashMessages = section.querySelectorAll('.franchise-form__success, .franchise-form__error');
  for (const msg of flashMessages) {
    setTimeout(() => msg.remove(), 5000);
  }

  // ── Scroll-to-form from any external CTA ───────────────────
  const scrollTriggers = document.querySelectorAll('[data-franchise-scroll-to-form]');
  for (const trigger of scrollTriggers) {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      section.scrollIntoView({ behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');
  if (typeof getpagi !== 'undefined' && getpagi !== null) {
    document.addEventListener('DOMContentLoaded', function () {
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click',
      });
    });
  }

  // document.getElementById('sortButton').addEventListener('click', function() {
  //      var sortDropdown = document.getElementById('sortDropdown');
  //      if (sortDropdown.classList.contains('none')) {
  //          sortDropdown.classList.remove('none');
  //          sortDropdown.classList.add('block');
  //      } else {
  //          sortDropdown.classList.remove('block');
  //          sortDropdown.classList.add('none');
  //      }
  //  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.product-slider', {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 20,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
